import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.less'],
  standalone: false,
})
export class BreadcrumbComponent {
  @Input() breadcrumbs: Array<{ label: string, url?: string }> = [];
}
